import { formatCurrency } from '@/lib/format'
import { BOAT_TYPE_LABELS, type BoatType } from '@/types/inventory'
import type { WantCriteria } from '@/types/boat-want'

// Human-readable chips summarizing what a want parsed down to — used on the
// customer card and in the dialog's detected-criteria line.
export function wantCriteriaChips(c: WantCriteria): string[] {
  const chips: string[] = []
  if (c.boat_type) chips.push(BOAT_TYPE_LABELS[c.boat_type as BoatType] ?? c.boat_type)
  if (c.make) chips.push(c.make)
  if (c.model) chips.push(`model: ${c.model}`)
  if (c.min_length_ft != null && c.max_length_ft != null)
    chips.push(`${c.min_length_ft}–${c.max_length_ft} ft`)
  else if (c.min_length_ft != null) chips.push(`${c.min_length_ft}+ ft`)
  else if (c.max_length_ft != null) chips.push(`under ${c.max_length_ft} ft`)
  if (c.min_year != null && c.max_year != null)
    chips.push(c.min_year === c.max_year ? `${c.min_year}` : `${c.min_year}–${c.max_year}`)
  else if (c.min_year != null) chips.push(`${c.min_year} or newer`)
  else if (c.max_year != null) chips.push(`${c.max_year} or older`)
  if (c.min_price != null && c.max_price != null)
    chips.push(`${formatCurrency(c.min_price)}–${formatCurrency(c.max_price)}`)
  else if (c.max_price != null) chips.push(`under ${formatCurrency(c.max_price)}`)
  else if (c.min_price != null) chips.push(`over ${formatCurrency(c.min_price)}`)
  if (c.max_engine_hours != null) chips.push(`under ${c.max_engine_hours} hrs`)
  if (c.condition) chips.push(c.condition)
  for (const kw of c.keywords ?? []) chips.push(`“${kw}”`)
  return chips
}

// "2021 Malibu Wakesetter" style label for a match card.
export function boatMatchName(m: { year: number; make: string; model: string }): string {
  const parts: string[] = []
  if (m.year > 0) parts.push(String(m.year))
  return [parts.join(' '), m.make, m.model].filter(Boolean).join(' ').trim() || 'Boat'
}
